import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, GlobeIcon, LibraryIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, SunIcon } from 'lucide-react';
import { MOCKUP_URL, heroTestimonials as heroQuotes } from '../data/content';
const chips = [{
  icon: ZapIcon,
  label: 'Acceso en 5 min',
  short: '5 min'
}, {
  icon: GlobeIcon,
  label: 'España y Latinoamérica',
  short: 'ES + LATAM'
}, {
  icon: LibraryIcon,
  label: '5 Tomos + 5 Bonos',
  short: '5 + 5'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Tarjeta de débito o crédito'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
const stats = [{
  value: '+1.200',
  label: 'familias hispanohablantes'
}, {
  value: '5',
  label: 'Tomos listos'
}, {
  value: '5',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-950 pb-16 pt-5 sm:pt-14" data-id="element-125" data-mp="384jsewrv5frv">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-126" data-mp="3j9ahhe4fas5o">
        <p className="font-display text-[11px] font-700 uppercase tracking-[0.28em] text-gold" data-id="element-127" data-mp="3o6u5v6uu4lbc">
          ☀ KODA DIGITAL
        </p>

        <h1 className="mt-3 font-display text-4xl font-900 leading-[1.04] tracking-tight text-white sm:mt-5 sm:text-5xl lg:text-[3.4rem]" style={{
        fontSize: "24px",
        textAlign: "center"
      }} data-id="element-128" data-mp="3e960lmzlrvex">
          Lo que necesitas saber antes de instalar paneles solares
          <span className="block text-gold" style={{
          fontSize: "20px"
        }} data-id="element-129" data-mp="35a2fyeksf7yb">
</span>
        </h1>
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-4 w-full max-w-[290px] sm:mt-6 sm:max-w-[420px]" data-id="element-130" data-mp="2qlogmdmky1mi">
          <img src={MOCKUP_URL} alt="Pack completo El Código Solar 360°: 5 tomos impresos, 5 bonos, plantillas, calculadora y app de monitoreo solar" className="h-auto w-full rounded-xl object-contain" width={420} height={420} data-id="element-131" data-mp="2ll0ht5s40ghq" />
        </motion.div>

        <p className="mt-3 max-w-2xl text-lg leading-relaxed text-slate-300 sm:mt-5" style={{
        fontSize: "16px",
        fontWeight: "400",
        fontFamily: "Avenir, sans-serif"
      }} data-id="element-132" data-mp="id00cg3n7mjd">
          Evaluá cualquier presupuesto solar sin ser técnico, y controlá cada número de tu instalación para no pagar de más
        </p>

        <ul className="mt-4 flex w-full items-center justify-center gap-2 sm:mt-5 sm:gap-2.5" data-id="element-133" data-mp="162m0p6vr47sy">
          {chips.map(chip => <li key={chip.label} className="flex items-center gap-1.5 whitespace-nowrap rounded-full border border-ink-700 bg-ink-900 px-3 py-1.5 text-[12.5px] font-500 leading-none text-slate-200 sm:px-3.5 sm:text-sm" data-id="element-134" data-mp="x14pa1tagual">
              <chip.icon className="h-3.5 w-3.5 flex-none text-gold sm:h-4 sm:w-4" aria-hidden="true" data-id="element-135" data-mp="3hpsft8nytx3m" />
              <span className="sm:hidden" data-id="element-136" data-mp="21amuv6fipmkr">{chip.short}</span>
              <span className="hidden sm:inline" data-id="element-137" data-mp="21b66y6ihlgqv">{chip.label}</span>
            </li>)}
        </ul>

        <a href="#precios" className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gold px-8 py-3.5 font-display text-base font-800 uppercase tracking-wide text-ink-950 transition-[transform,background-color] duration-150 ease-smooth hover:bg-gold-400 active:scale-[0.985] sm:w-auto sm:text-lg" style={{
        height: "64px"
      }} data-id="element-138" data-mp="267wluqik26ap">
          <SunIcon className="h-5 w-5" aria-hidden="true" data-id="element-139" data-mp="2p1jylvx5tdkx" />
          Quiero mi Código Solar ahora
        </a>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[13px] text-slate-400" data-id="element-140" data-mp="2tyaeai51y75t">
          {trust.map(item => <li key={item.label} className="flex items-center gap-1.5" data-id="element-141" data-mp="uou2r8n8duaw">
              <item.icon className="h-3.5 w-3.5 text-leaf-400" aria-hidden="true" data-id="element-142" data-mp="zm2lbacak0co" />
              {item.label}
            </li>)}
        </ul>
      </div>

      <div className="mx-auto mt-12 w-full max-w-6xl px-4 sm:px-6" data-id="element-143" data-mp="3vigos9huyjzw">
        <dl className="grid grid-cols-2 gap-x-6 gap-y-5 border-y border-ink-800 py-6 text-center sm:grid-cols-4" data-id="element-144" data-mp="e9jybwc3bdsy">
          {stats.map(stat => <div key={stat.label} data-id="element-145" data-mp="9bs8r8yx43rx">
              <dt className="sr-only" data-id="element-146" data-mp="98e7y55wk2ml">{stat.label}</dt>
              <dd data-id="element-147" data-mp="3hrbvdp532ny0">
                <span className="block font-display text-2xl font-800 text-white" data-id="element-148" data-mp="3hqsbw3zsbrhv">
                  {stat.value}
                </span>
                <span className="mt-0.5 block text-xs leading-snug text-slate-400" data-id="element-149" data-mp="3rg3lrsuhx06t">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <ul className="mt-10 grid gap-3 md:grid-cols-3" data-id="element-150" data-mp="2yzsvvsa9ps0q">
          {heroQuotes.map(item => <li key={item.name} className="flex flex-col rounded-xl border border-ink-800 bg-ink-900 p-5" data-id="element-151" data-mp="2u0ppo4ijxfr6">
              <p className="text-xs tracking-widest text-gold" aria-label="5 de 5 estrellas" data-id="element-152" data-mp="19hvo6u3huzax">
                ★★★★★
              </p>
              <p className="mt-2 text-[15px] leading-relaxed text-slate-200" data-id="element-153" data-mp="1ebgpav0dw9ec">“{item.quote}”</p>
              <p className="mt-auto flex items-center gap-2 pt-4 text-xs text-slate-400" data-id="element-154" data-mp="ziekgi7syvhl">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-ink-700 font-display text-[11px] font-700 text-gold" data-id="element-155" data-mp="14ju3y5uc0txv">
                  {item.initials}
                </span>
                {item.name} · {item.city}
              </p>
            </li>)}
        </ul>
      </div>
    </header>;
}